import { css, cx } from "@emotion/css"

import RadioAndCheckBoxBase from "../RadioAndCheckBoxBase"

type Props = Omit<React.ComponentProps<typeof RadioAndCheckBoxBase>, "type" | "renderIcon">

const checkedColor = "#1f5da0"
const noCheckedColor = "#4d4d4d"

const Radio = (props: Props) => {
  const { checked } = props

  const stroke = checked ? checkedColor : noCheckedColor
  const fill = checked ? checkedColor : "none"

  return (
    <RadioAndCheckBoxBase
      type="radio"
      renderIcon={(isFocusVisible) => (
        <svg className={cx(styles.circle, isFocusVisible && styles.focus)}>
          <circle r={6} cx={6.5} cy={6.5} strokeWidth={1} stroke={stroke} fill="none" />
          <circle r={4} cx={6.5} cy={6.5} strokeWidth={0} fill={fill} />
        </svg>
      )}
      {...props}
    />
  )
}
export default Radio

const styles = {
  circle: css`
    width: 13px;
    height: 13px;
    border-radius: 50%;
    &:hover {
      opacity: 0.7;
    }
  `,
  focus: css`
    outline: 1px auto black;
    outline-offset: 3px;
  `,
}
